import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-admin-view-user')) {
  var userId = document.getElementById('react-component-g4-logistics-portal-admin-view-user').getAttribute('data-user-id');
  ReactDOM.render(<PortalAccountsTable
      url = {"/api/v1/portal/portal-admin/users/view/"+userId}
      message_if_none = 'User not found or available for viewing.'
    />,

    document.getElementById('react-component-g4-logistics-portal-admin-view-user'));
}
